/**
 * useAuthRhythm — vertical rhythm scale for every auth screen.
 *
 * Replaces the old `useAuthSpacing(isWide, isCompact)` signature, which
 * required each screen to derive its own breakpoints from
 * `useWindowDimensions()`. This version reads `useBreakpoint()` internally,
 * so callers get one arg-less hook and the app keeps a single source of
 * breakpoint truth.
 *
 * Values scale with `isDesktop` only; the short-phone `isCompact` branch
 * was retired — 700px-tall devices are rare enough that a single spacing
 * pass reads correctly on every form factor.
 */
import { SPACING } from '../brand'
import { useBreakpoint } from './use-breakpoint'

export function useAuthRhythm() {
  const { isDesktop } = useBreakpoint()
  const isWide = isDesktop

  return {
    headerTop: isWide ? SPACING.md : SPACING.sm + SPACING.xs,
    headlineToSub: isWide ? SPACING.sm + 2 : SPACING.sm,
    subToForm: isWide ? SPACING.xl + SPACING.xs : SPACING.xl,
    formToAction: isWide ? SPACING.xl : SPACING.xl - SPACING.xs,
    actionToAlt: isWide ? SPACING.xl + SPACING.xs : SPACING.xl,
    dividerToSocial: isWide ? SPACING.xl - SPACING.xs : SPACING.lg - SPACING.xs,
    altToFooter: isWide ? SPACING.xl + SPACING.xs : SPACING.xl,
  }
}
